import { render, staticRenderFns } from "./QualityControlItemRow.vue?vue&type=template&id=2da27ce2&scoped=true"
import script from "./QualityControlItemRow.vue?vue&type=script&lang=js"
export * from "./QualityControlItemRow.vue?vue&type=script&lang=js"
import style0 from "./QualityControlItemRow.vue?vue&type=style&index=0&id=2da27ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da27ce2",
  null
  
)

export default component.exports